module.exports = __webpack_public_path__ + "static/img/1.5d6ac77.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/2/eng/1.png
// module id = 7Jha
// module chunks = 0